export const chartConstants = {
  defaultHeight: 350
};
